export default __webpack_public_path__ + "static/media/img_empty_countdown@2x.3af5fe58.png";